import React from 'react';

import classNames from 'classnames';

const Block = ({ backgroundUrl, backgroundColor, hasDecoration, className, id, children }) => (
  <div className={classNames('block', {
    decoration: hasDecoration,
  }, className)} style={
    backgroundUrl ? {
      backgroundImage: `url(${backgroundUrl})`,
    } : {} +
    backgroundColor ? {
      backgroundColor: backgroundColor
    } : {}
  } id={id}>
    <div className="container">
      {children}
    </div>
  </div>
)

export default Block;



// WEBPACK FOOTER //
// ./src/components/block.js